module.exports = __webpack_public_path__ + "static/media/logo-1.7330a4f6.png";